module.exports = __webpack_public_path__ + "img/IMG_8157_L_WoodMatted_MockedUp.c68f8f9a.jpg";